import { trackEvent } from './index'

const isM = process.client && !navigator.userAgent.includes('AlipayHK')

export const customersEvent = {
  /**
     *
     * @param content 点击内容
     * @param ptype 一级分类
     * @param stype 二级分类
     */
  clickEvent: (content: string, ptype: string, stype: string) => {
    trackEvent({
      eventid: 11066,
      label: 'Customersupport',
      category: 'PC-Helpcenter',
      action: 'click',
      value: {
        ClickContent: content,
        PrimaryType: ptype,
        SecondaryType: stype,
      },
    })
  },
  pageShowEvent: ({ servicetypes }: { servicetypes: string }) => {
    trackEvent({
      eventid: 11065,
      label: 'Customersupport',
      category: 'PC-Helpcenter',
      action: 'show',
      value: {
        servicetypes,
      },
    })
  },
  questionShowEvent: (
    Question: string,
    PrimaryType: string,
    SecondaryType: string,
  ) => {
    trackEvent({
      eventid: 11071,
      label: 'Questionlist',
      category: 'PC-Helpcenter',
      action: 'show',
      value: {
        Question,
        PrimaryType,
        SecondaryType,
      },
    })
  },
  questionClickEvent: (
    Question: string,
    PrimaryType: string,
    SecondaryType: string,
    ClickContent: string,
  ) => {
    trackEvent({
      eventid: 11072,
      label: 'Questionlist',
      category: 'PC-Helpcenter',
      action: 'click',
      value: {
        Question,
        PrimaryType,
        SecondaryType,
        ClickContent,
      },
    })
  },
  chatFloatShowEvent: () => {
    trackEvent({
      eventid: 11067,
      label: 'Chatfloating',
      category: 'PC-Helpcenter',
      action: 'show',
      value: {},
    })
  },
  chatFloatClickEvent: (ClickContent: string) => {
    trackEvent({
      eventid: 11068,
      label: 'Chatfloating',
      category: 'PC-Helpcenter',
      action: 'click',
      value: {
        ClickContent,
      },
    })
  },
  callFloatShowEvent: ({
    type,
    isOtherNumber,
  }: {
    type: string
    isOtherNumber: 'yes' | 'no'
  }) => {
    trackEvent({
      eventid: 11069,
      label: 'Callfloating',
      category: 'PC-Helpcenter',
      action: 'show',
      value: {
        type,
        isOtherNumber,
      },
    })
  },
  callFloatClickEvent: (ClickContent: string) => {
    trackEvent({
      eventid: 11070,
      label: 'Callfloating',
      category: 'PC-Helpcenter',
      action: 'click',
      value: {
        ClickContent,
      },
    })
  },
  questionFormClickEvent: (ProductName: string, OrderId: string) => {
    trackEvent({
      eventid: 11073,
      label: 'Questionform',
      category: 'PC-Helpcenter',
      action: 'click',
      value: {
        ProductName,
        OrderId,
      },
    })
  },
  /**
   * 邮件工单在线客服入口点击
   */
  questionFormToChatClickEv: () => {
    trackEvent({
      eventid: 12962,
      category: 'PC-Helpcenter',
      label: 'Questionformtochat',
      action: 'click',
      value: {},
    })
  },
  /**
   * 邮件工单在线客服浮层点击
   * @param val ClickContent 点击内容：
   *  - 若选择具体分类则埋分类名称
   *  - 若关闭浮层则埋 "Close"
   */
  questionFormToChatFloatingClickEv: (val: { ClickContent: string }) => {
    trackEvent({
      eventid: 12963,
      category: 'PC-Helpcenter',
      label: 'Questionformtochatfloating',
      action: 'click',
      value: val,
    })
  },
}
